import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TechInsurance } from 'src/app/models/tech/tech-insurance.model';
import { ApiError } from 'src/app/models/api/api-error.model';
import { TechService } from 'src/app/services/tech.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Component, Inject } from '@angular/core';

import isNumeric from 'validator/es/lib/isNumeric';
import isDate from 'validator/es/lib/isDate';

@Component({
  selector: 'app-user-tech-insurance-dialog',
  template: `<app-dea-dialog-wrapper>
    <div class="fw-semibold fs-4">
      {{ this.data?.docId === undefined ? '' : 'Modifica ' }}Assicurazione
    </div>
    <div class="v-spacer"></div>
    <form
      [formGroup]="userInsuranceForm"
      enctype="multipart/form-data"
      class="m-0 p-0 d-flex flex-column gap-3"
    >
      <app-dea-label [label]="'Scadenza:'"></app-dea-label>
      <input
        type="date"
        formControlName="expiration"
        class="form-control dea-form-input mb-3"
        placeholder="Scadenza"
      />
      <app-dea-label [label]="'Costo (€):'"></app-dea-label>
      <input
        type="text"
        formControlName="value"
        class="form-control dea-form-input mb-3"
        placeholder="Costo"
        justNumber
      />
      <app-dea-label [label]="'Allegato: (Opzionale)'"></app-dea-label>
      <div>
        <input
          type="file"
          formControlName="file"
          accept="image/png,image/jpeg,.pdf"
          class="form-control dea-form-input mb-1"
          placeholder="Seleziona un file"
          (change)="onFileChange($event)"
        />
        <div class="fw-lighter mb-3" style="font-size: 0.5rem;">
          Formati accettati: PDF - PNG/JPG/JPEG | Dimensione Masima: 48Mb x 1
        </div>
      </div>
      <div class="text-danger">{{ error?.message }}</div>
    </form>
    <div class="m-0 p-0 mt-3 gap-2" mat-dialog-actions align="end">
      <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()">
        Annulla
      </button>
      <button
        *ngIf="!loading"
        (click)="onConfirm()"
        class="px-5 py-1"
        mat-flat-button
        color="primary"
      >
        {{ this.data?.docId === undefined ? 'Crea' : 'Modifica' }}
      </button>
      <button *ngIf="loading" class="px-5 py-1" mat-flat-button disabled>
        <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon>
        {{ this.data?.docId === undefined ? 'Creazione' : 'Aggiornamento' }}
      </button>
    </div>
  </app-dea-dialog-wrapper>`,
  styles: [],
})
export class UserTechInsuranceDialogComponent {
  public loading: boolean = false;
  public error?: ApiError;

  public userInsuranceForm: FormGroup;

  constructor(
    private _dialogRef: MatDialogRef<UserTechInsuranceDialogComponent>,
    private _techService: TechService,
    @Inject(MAT_DIALOG_DATA)
    public data?: {
      userId?: string;
      deviceId?: string;
      docId?: string;
    },
  ) {
    this.userInsuranceForm = new FormGroup({
      owner: new FormControl(this.data?.userId),
      device: new FormControl(this.data?.deviceId),
      expiration: new FormControl(this.getStartDate()),
      value: new FormControl(150),
      file: new FormControl(null),
      document: new FormControl(null),
    });
    if (this.data?.docId !== undefined) {
      this._techService.getTechBlockDetails(this.data?.docId).subscribe({
        next: (data: any) => {
          const insuranceData = new TechInsurance(data.data);
          this.userInsuranceForm = new FormGroup({
            owner: new FormControl(insuranceData?.owner?.id),
            device: new FormControl(insuranceData?.device?.id),
            expiration: new FormControl(
              insuranceData?.expiration?.toISOString().slice(0, 10),
            ),
            value: new FormControl(insuranceData?.value),
            file: new FormControl(null),
            document: new FormControl(null),
          });
        },
        error: (error: any) => console.error('Get Tech Details Error: ', error),
      });
    }
  }

  getStartDate() {
    const startYear = (
      new Date().getFullYear() + (new Date().getMonth() > 5 ? 1 : 0)
    ).toString();
    return `${startYear}-08-31`;
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.userInsuranceForm?.patchValue({ document: file });
    }
  }

  onConfirm(): void {
    this.loading = true;
    this.error = undefined;
    const formData = new FormData();
    var data = this.userInsuranceForm.value;
    formData.append('owner', data.owner);
    formData.append('device', data.device);
    if (isDate(data.expiration)) {
      formData.append('expiration', data.expiration);
    }
    if (isNumeric(`${data.value}`)) {
      formData.append('value', data.value);
    }
    if (data.document) {
      const file: any = this.userInsuranceForm?.get('document')?.value;
      formData.append(
        'documento',
        file,
        file.name || new Date().toISOString().slice(0, 10),
      );
    }
    const subscription = {
      next: (_: any) => this._dialogRef.close(true),
      error: (error: any) => {
        this.error = new ApiError(error);
        console.error('User Post/Patch Insurance Error: ', error);
      },
    };
    if (this.data?.docId) {
      this._techService
        .patchInsurance(formData, this.data?.docId)
        .subscribe(subscription)
        .add(() => (this.loading = false));
    } else {
      this._techService
        .postInsurance(formData, this.data?.userId)
        .subscribe(subscription)
        .add(() => (this.loading = false));
    }
  }

  onDismiss(): void {
    this._dialogRef.close(false);
  }
}
